import { render, staticRenderFns } from "./com-upload-file.vue?vue&type=template&id=b50dd004&scoped=true&"
import script from "./com-upload-file.vue?vue&type=script&lang=js&"
export * from "./com-upload-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50dd004",
  null
  
)

export default component.exports